<template>
  <div class="filterWapper">
    <div class="filter">
      <div class="filter__action action">
        <div class="action__date">
          <div class="date-group">
            <UiBaseIcon iconName="calendar" color="#3b4556" @click="showFillter" />
            <div class="div-input" @click="showFillter" :key="dateInputKey">
              {{
                $d(new Date(this.day.createdAtMin), 'long')
              }}{{ ', ' }}
              {{
                $d(new Date(this.day.createdAtMax), 'long')
              }}
            </div>
            <div class="calendar-group" v-show="isFormDateFicker">
              <ul class="tabs">
                <li v-for="tab in dateTabs" :key="tab.id" :class="{ active: tab.id === activeTab }"
                  @click="changeTab(tab.id)">{{ $t(tab.name) }}</li>
              </ul>
              <div class="tab-content" v-show="activeTab === 0">
                <ul class="tabs tabs--white">
                  <li v-for="tab in dateRangeTabs" :key="tab.id" :class="{ active: tab.id === dateRangeActive }"
                    @click="dateRangeActive = tab.id">
                    {{ $t(tab.name) }}
                  </li>
                </ul>
                <Year v-show="dateRangeActive === 0" @changeYear="changeDay" />
                <Month v-show="dateRangeActive === 2" @changeMonth="changeDay" />
                <Weeks v-show="dateRangeActive === 3" @changeWeek="changeDay" />
                <Day v-show="dateRangeActive === 4" @changeDay="changeDay" />
                <Hours v-show="dateRangeActive === 5" />
                <div class="error" v-if="error">
                  <p>Time must not exceed today</p>
                </div>
                <div class="time-result">
                  <div class="date-value" :key="compareDateKey">
                    {{
                      $d(new Date(this.day.createdAtMin), 'short')
                    }}{{ ', ' }}
                    {{
                      $d(new Date(this.day.createdAtMax), 'short')
                    }}
                  </div>
                  <div class="action">
                    <button type="button" class="btn" @click="onFilter">{{ $t('apply') }}</button>
                  </div>
                </div>
              </div>
              <div class="tab-content-ranger" v-show="activeTab === 1">
                <date-picker v-model="time_ranger" range :open="showDateRanger" :show-time-panel="showTimeRangePanel"
                  type="datetime" :show-second="false" :disabled-date="disabledAfterToday" @input="changeDateRanger"
                  :key="datePickerKey" :lang="getLangForDatepicker($i18n.locale)">
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimeRangePanel">
                      {{ showTimeRangePanel ? $t('select_date') : $t('select_time') }}
                    </button>
                  </template>
                </date-picker>
                <div class="time-result">
                  <div class="date-value" :key="dateRangeKey">
                    {{
                      $d(new Date(this.day.createdAtMin), 'long')
                    }}{{ ', ' }}
                    {{
                      $d(new Date(this.day.createdAtMax), 'long')
                    }}
                  </div>
                  <div class="action">
                    <button type="button" class="btn" @click="onFilter">{{ $t('apply') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$route.name === 'global' || $route.name === 'global-stores'" class="column-filter-wrapper-filter-ui">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('store')">
            {{ $t('multiple') }} ({{listStore.filter((store) => store.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'store'">
            <ul ref="columnsList">
              <li v-for="store in listStore" :key="store.id">
                <input type="checkbox" v-model="store.visible" v-bind:id="store.id" />
                <label v-bind:for="store.id">
                  <span>{{ store.name }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container">
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div class="outlet-group">
          <select v-if="$route.name !== 'global' && $route.name !== 'global-stores'" name="sourceItem"
            v-model="sourceItem" @change="onChangeOutlet">
            <option :value="'both'">{{ $t('all') }}</option>
            <option :value="'online'">{{ $t('online') }}</option>
            <option :value="'in_store'">{{ $t('in_store') }}</option>
          </select>
        </div>
        <div v-if="sourceItem !== 'online' && $route.name !== 'global' && $route.name !== 'global-stores'"
          class="column-filter-wrapper-filter-ui" :key="outletsKey">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('outlet')">
            {{ $t('outlet') }} ({{listOutlet.filter((outlet) => outlet.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'outlet'">
            <ul ref="columnsList">
              <li v-for="outlet in listOutlet" :key="outlet.id">
                <input type="checkbox" v-model="outlet.visible" v-bind:id="outlet.id" @change="onSelectOutlet()" />
                <label v-bind:for="outlet.id">
                  <span>{{ outlet.name }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container d-flex justify-content-between align-items-center">
              <div>
                <input type="checkbox" v-model="checkAllOutlets" @change="checkAllOutletsAction($event)"
                  id="check-all" />
                <label for="check-all">
                  <span>{{ $t('check_all') }}</span>
                </label>
              </div>
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="sourceItem !== 'online' && $route.name !== 'global' && $route.name !== 'global-stores'"
          class="column-filter-wrapper-filter-ui" :key="registersKey">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('register')">
            {{ $t('register') }} ({{listRegister.filter((register) => register.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'register'">
            <ul ref="columnsList">
              <li v-for="register in listRegister" :key="register.id">
                <input type="checkbox" v-model="register.visible" v-bind:id="register.id" />
                <label v-bind:for="register.id">
                  <span>{{ register.nameDisplay || register.name }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container">
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="($route.name === 'productSold' || $route.name === 'revenueByProduct') && $route.name !== 'global' && $route.name !== 'global-stores'"
          class="column-filter-wrapper-filter-ui" :key="productTypesKey">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('productTypes')">
            {{ $t('product_type') }} ({{productTypes.filter((type) => type.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'productTypes'">
            <ul ref="columnsList">
              <li v-for="item in productTypes" :key="item.value">
                <input type="checkbox" v-model="item.visible" v-bind:id="item.value" />
                <label v-bind:for="item.value">
                  <span>{{ $t(item.label) }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container">
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="
          ['dashboard', 'orderStatus', 'timeInStatus', 'revenueByProduct', ...revenueListName].includes($route.name) &&
          $route.name !== 'global' &&
          $route.name !== 'global-stores' && !!orderStatus.length
        " class="column-filter-wrapper-filter-ui" :key="orderStatusKey">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('orderStatus')">
            {{ $t('order_status') }} ({{orderStatus.filter((status) => status.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'orderStatus'">
            <ul ref="columnsList">
              <li v-for="status in orderStatus" :key="status.value">
                <input type="checkbox" v-model="status.visible" v-bind:id="status.value" />
                <label v-bind:for="status.value">
                  <span>{{ orderStatusLabel[status.label] ? $t(orderStatusLabel[status.label]) : status.label }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container d-flex justify-content-between align-items-center">
              <div>
                <input type="checkbox" :checked="orderStatus.every((status) => status.visible)"
                  :indeterminate.prop="orderStatus.filter((status) => status.visible).length !== orderStatus.length && orderStatus.filter((status) => status.visible).length !== 0"
                  @change="checkAllOrderStatus($event)" id="check-all" />
                <label for="check-all">
                  <span>{{ $t('check_all') }}</span>
                </label>
              </div>
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="$route.name === 'paymentStatus' && $route.name !== 'global' && $route.name !== 'global-stores'"
          class="column-filter-wrapper-filter-ui" :key="paymentStatusKey">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('paymentStatus')">
            {{ $t('payment_status') }} ({{paymentStatus.filter((status) => status.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'paymentStatus'">
            <ul ref="columnsList">
              <li v-for="status in paymentStatus" :key="status.value">
                <input type="checkbox" v-model="status.visible" v-bind:id="status.value" />
                <label v-bind:for="status.value">
                  <span>{{ $t(status.label) }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container">
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="$route.name === 'tippings'" class="column-filter-wrapper-filter-ui" :key="salesPersonKey">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('tippings')">
            {{ $t('sales_person') }} ({{listSalespersons.filter((status) => status.visible).length}})
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'tippings'">
            <ul ref="columnsList">
              <li v-for="salesperson in listSalespersons" :key="salesperson.id">
                <input type="checkbox" v-bind:id="salesperson.id" v-model="salesperson.visible" />
                <label v-bind:for="salesperson.id">
                  <span>{{ `${salesperson.firstName} ${salesperson.lastName}` }}</span>
                </label>
              </li>
            </ul>
            <div class="apply-container">
              <button class="btn customize-button" @click="toggleColumnFilter()">
                {{ $t('apply') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="$route.name === 'revenueByCategory'" class="column-filter-wrapper-filter-ui">
          <button class="btn btn-csv multi-select-button" @click="closeMultiSelect('allCategories')">
            {{ $t('all_categories') }}
          </button>
          <div class="popup-container" v-if="isShowColumnsSelect && popupType === 'allCategories'">
            <UiFilterCategories @onFilterCategory="onFilterCategory" />
          </div>
        </div>
      </div>
      <div class="filter__button" v-if="
        $route.name !== 'timeInStatus' &&
        $route.name !== 'global' &&
        $route.name !== 'global-stores' &&
        $route.name !== 'sell_report' &&
        $route.name !== 'orderStatus' &&
        $route.name !== 'paymentStatus' &&
        $route.name !== 'salesOrder' &&
        $route.name !== 'averageDuration' &&
        $route.name !== 'dashboard' &&
        $route.name !== 'salesReport' &&
        $route.name !== 'revenueByProduct' &&
        $route.name !== 'productSold' &&
        $route.name !== 'tippings' &&
        $route.name !== 'dailyReport' &&
        $route.name !== 'monthlyReport'
      ">
        <button v-if="$route.name === 'totalRevenue'" @click="exportPdf" class="export-pdf">{{ $t('export') }}
          PDF</button>
        <download-excel class="btn btn-csv" :data="getJsonData" :fields="getJsonFields" :worksheet="$route.name"
          :name="`CReport_${$route.name}_by_${fillterType.toLowerCase()}.xls`">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      
      <div class="filter__button" v-if="$route.name === 'dailyReport'">
        <button @click="exportDailyPdf" class="export-pdf">{{ $t('export') }}
          PDF</button>
        <download-excel class="btn btn-csv" :fields="dailyReportData.fieldExport" :worksheet="$route.name"
          :name="`CReport_${$route.name}_${new Date().getTime()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'monthlyReport'">
        <button @click="exportMonthlyPdf" class="export-pdf">{{ $t('export') }}
          PDF</button>
        <download-excel class="btn btn-csv" :fields="monthlyReportData.fieldExport" :worksheet="$route.name"
          :name="`CReport_${$route.name}_${new Date().getTime()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'revenueByProduct'">
        <download-excel class="btn btn-csv" :fields="getJsonFields" :worksheet="$route.name"
          :name="`CReport_${$route.name}_by_${fillterType.toLowerCase()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'productSold'">
        <download-excel class="btn btn-csv" :fields="getJsonFields" :worksheet="$route.name"
          :name="`CReport_${$route.name}_by_${fillterType.toLowerCase()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'averageDuration'">
        <download-excel class="btn btn-csv" :fields="getJsonFieldsOrder" :worksheet="$route.name"
          :name="`CReport_orders_duration_by_${fillterType.toLowerCase()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'tippings'">
        <download-excel class="btn btn-csv" :fields="getJsonFieldsOrder" :worksheet="$route.name"
          :name="`CReport_orders_duration_by_${fillterType.toLowerCase()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'timeInStatus'">
        <download-excel class="btn btn-csv" :fields="getJsonFieldsOrder" :worksheet="$route.name"
          :name="`CReport_orders_duration_by_${fillterType.toLowerCase()}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button"
        v-if="$route.name === 'orderStatus' || $route.name === 'paymentStatus' || $route.name === 'salesOrder'">
        <download-excel class="btn btn-csv" :fields="getJsonFieldsOrder" :worksheet="$route.name"
          :name="`CReport_orders_by_${$route.name}.xls`" :fetch="onGetDataExport">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
      <div class="filter__button" v-if="$route.name === 'salesReport'">
        <button class="btn btn-csv" @click="toogleShowModal(true)">
          {{ $t('export_excel') }}
        </button>
      </div>
      <div v-if="$route.name === 'sell_report'">
        <download-excel class="btn btn-csv" :data="getJsonDataSellReport" :fields="getJsonFieldsSellReport"
          :worksheet="$route.name" :name="`CReport_${$route.name}_by_${fillterType.toLowerCase()}.xls`">
          {{ $t('export_excel') }}
        </download-excel>
      </div>
    </div>
    <div class="filter-fields" v-if="isShowFilterForm">
      <div class="fields-icon">
        <UiBaseIcon iconName="sortUp" color="#fff" />
      </div>
      <form class="form-filter">
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('revenue') }}</label>
            <input type="text" name="revenue" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('cost') }}</label>
            <input type="text" name="cost" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('gross_profit') }}</label>
            <input type="text" name="grossProfit" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('margin') }}</label>
            <input type="text" name="margin" />
          </div>
        </div>
        <!-- col-2 -->
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('tax') }}</label>
            <input type="text" name="tax" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('total_sales') }}</label>
            <input type="text" name="totalSales" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('cart_value') }}</label>
            <input type="text" name="cartValue" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wapper">
            <label>{{ $t('order_count') }}</label>
            <input type="text" name="orderCount" />
          </div>
        </div>
        <div class="filter-fields-action">
          <button type="reset" class="btn btn-reset">
            <UiBaseIcon iconName="refresh" color="#fff" />{{ $t('reset_filter') }}
          </button>
          <button type="submit" class="btn btn-apply">
            <UiBaseIcon iconName="tick" color="#fff" /> {{ $t('apply_filter') }}
          </button>
        </div>
      </form>
    </div>
    <UiModal :show="showModalDateExport" :closeOnOverlay="true" @toogleShowModal="toogleShowModal">
      <div>
        <p class="label-select">{{ $t('select_export_date_format') }}:</p>
        <select class="select-date" v-model="dateFormatExport">
          <option v-for="format in dataDateFormats" :key="format.value" :value="format.value">{{ format.label }}
          </option>
        </select>
        <div class="box-button">
          <button class="button cancle" @click="toogleShowModal(false)">{{ $t('cancel') }}</button>
          <download-excel class="button accept" :fields="getJsonFields" :worksheet="$route.name"
            :name="`CReport_orders_by_${$route.name}.xls`" :fetch="onGetDataExport">
            {{ $t('export') }}
          </download-excel>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { setLocalStorage, getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiBaseIcon from '@/components/icons/UiBaseIcon'
import UiModal from '@/components/UiModal'
import UiFilterCategories from '@/components/filterBar/UiFilterCategories.vue'
import Year from './year'
import Month from './month'
import Weeks from './weeks'
import Day from './day'
import Hours from './hours'
import dateTime from '@/constants/dateTime'
import DatePicker from 'vue2-datepicker'
import en from 'vue2-datepicker/locale/en'
import fr from 'vue2-datepicker/locale/fr'
import moment from 'moment'
import 'vue2-datepicker/index.css'
import orderStatus from '@/constants/orderStatus'
import paymentStatus from '@/constants/paymentStatus'
import fulfillmentStatus from '@/constants/fulfillmentStatus'
import source from '@/constants/source'
import reportType from '@/config/reportType'
import formatNum from 'format-num'
import fontNotoSanThai from '@/assets/fonts/fontNotoSanThai'
import i18n from '@/i18n'
import { orderStatusLabel } from '@/constants/order'
export default {
  name: 'UiFilter',
  components: {
    UiBaseIcon,
    Year,
    Month,
    Weeks,
    Day,
    Hours,
    DatePicker,
    UiModal,
    UiFilterCategories
  },
  props: {
    disableCompareDate: {
      type: Boolean,
      default: false
    },
    queryMode: {
      type: String,
      default: 'DATE'
    },
    statesQuery: {
      type: Array
    }
  },
  data() {
    let dateTabs = []

    if (this.disableCompareDate) {
      dateTabs = [dateTime.dateTabs[1]]
    } else {
      dateTabs = dateTime.dateTabs
    }

    return {
      isShowColumnsSelect: false,
      isShowFilterForm: false,
      isFormDateFicker: false,
      showTimeRangePanel: false,
      activeTab: 1,
      dateRangeActive: 4, // default 4
      dateTabs: dateTabs,
      checkAllOutlets: true,
      dateRangeTabs: dateTime.dateRangeTabs,
      day: {
        mode: this.queryMode,
        createdAtMin: null,
        createdAtMax: null
      },
      isMergedStatuses: false,
      isMergedSalesperson: false,
      dateRangeKey: 0,
      compareDateKey: 1,
      outletsKey: 2,
      registersKey: 3,
      salesPersonKey: 4,
      paymentStatusKey: 5,
      orderStatusKey: 6,
      productTypesKey: 7,
      dateInputKey: 8,
      datePickerKey: 9,
      orderStatus: [],
      orderStatusLabel: orderStatusLabel,
      paymentStatus: [
        {
          value: 'paid',
          visible: true,
          label: 'paid'
        },
        {
          value: 'unpaid',
          visible: true,
          label: 'unpaid'
        },
        {
          value: 'partially_paid',
          visible: true,
          label: 'partially_paid'
        },
        {
          value: 'exchanged',
          visible: true,
          label: 'exchanged'
        },
        {
          value: 'refunded',
          visible: true,
          label: 'refunded'
        },
        {
          value: 'partially_refunded',
          visible: true,
          label: 'partially_refunded'
        }
      ],
      productTypes: [
        {
          value: 'simple',
          visible: true,
          label: 'simple'
        },
        {
          value: 'configurable',
          visible: true,
          label: 'configurable'
        },
        {
          value: 'bundle',
          visible: true,
          label: 'bundle'
        },
        {
          value: 'composite',
          visible: true,
          label: 'composite'
        },
        {
          value: 'grouped',
          visible: true,
          label: 'grouped'
        },
        {
          value: 'virtual',
          visible: true,
          label: 'virtual'
        },
        {
          value: 'giftcard',
          visible: true,
          label: 'gift_card_certificate'
        }
      ],
      showDateRanger: false,
      time_ranger: null,
      fillterType: this.queryMode,
      listLabel: [],
      json_fields: {},
      json_data: [],
      range: 4,
      sourceItem: (this.getQuery && this.getQuery.reportingMode) || 'in_store',
      state: null,
      status: null,
      now: new Date(),
      error: false,
      timeChange: 0,
      timeMaxChange: 0,
      show: false,
      listOutlet: [],
      listOutletOld: [],
      isMergedOutlets: false,
      popupType: '',
      listRegister: [],
      listSalespersons: [],
      statesQueryData: this.statesQuery,
      dateFormatExport: 'DD/MM/YYYY HH:mm',
      showModalDateExport: false,
      dataDateFormats: [
        {
          value: 'DD/MM/YYYY HH:mm',
          label: 'DD/MM/YYYY HH:mm (Day/Month/Year Hour:Minute)'
        },
        {
          value: 'DD/MM/YYYY',
          label: 'DD/MM/YYYY (Day/Month/Year)'
        },
        {
          value: 'MM/DD/YYYY',
          label: 'MM/DD/YYYY (Month/Day/Year)'
        },
        {
          value: 'MM/DD/YYYY HH:mm',
          label: 'MM/DD/YYYY HH:mm (Month/Day/Year Hour:Minute)'
        },
        {
          value: 'MMMM Do YYYY',
          label: 'MMMM Do YYYY (Month Day Year)'
        },
        {
          value: 'MMMM Do YYYY HH:mm',
          label: 'MMMM Do YYYY HH:mm (Month Day Year Hour:Minute)'
        }
      ],
      revenueListName: [
        'totalRevenue',
        'revenueByCustomer',
        'revenueByOutlet',
        'netRevenue',
        'revenueByCategory',
        'seller',
        'cashier',
        'salesReport',
        'payment'
      ]
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      salesOrderData: 'report/getSalesOrderData',
      getQuery: 'report/getQuery',
      getColsData: 'report/getColsData',
      getJsonFields: 'report/getJsonFields',
      getJsonData: 'report/getJsonData',
      getJsonDataOrder: 'report/getJsonDataOrder',
      getJsonFieldsOrder: 'report/getJsonFieldsOrder',
      getListOutLet: 'outlet/getListOutLet',
      getSellReport: 'report/getSellReport',
      getJsonFieldsSellReport: 'report/getJsonFieldsSellReport',
      getJsonDataSellReport: 'report/getJsonDataSellReport',
      getCustomStatuses: 'order/getCustomStatuses',
      listStore: 'store/getListStore',
      count_items: 'report/getCountItems',
      isExporting: 'report/getIsExporting',
      salespersons: 'report/getSalespersons',
      listCatalogFilter: 'catalog/getListCatalogFilter',
      orderReport: 'report/getOrderReportData',
      dailyReportData: 'report/getDailyReportData',
      monthlyReportData: 'report/getMonthlyReportData',
      dailyTaxReportData: 'report/getDailyTaxReportData'
    })
  },
  updated() {
    setTimeout(() => {
      if (!this.isMergedStatuses && (this.getCustomStatuses || []).length > 0) {
        if (this.getQuery.states) {
          this.orderStatus = [...this.orderStatus, ...this.getCustomStatuses].map((status) => ({
            ...status,
            visible: this.getQuery.states.indexOf(status.value) > -1
          }))
        } else {
          this.orderStatus = [...this.orderStatus, ...this.getCustomStatuses].map((status) => ({ ...status, visible: true }))
        }
        this.isMergedStatuses = true
      }
      var oldListOutletIds = this.listOutletOld.map((outlet) => outlet.id)
      var newListOutletIds = this.getListOutLet.map((outlet) => outlet.id)
      var isChangeStore = JSON.stringify(oldListOutletIds) !== JSON.stringify(newListOutletIds) && this.listOutletOld.length > 0
      if ((!this.isMergedOutlets || isChangeStore) && (this.getListOutLet || []).length > 0) {
        this.listOutlet = [...(isChangeStore ? [] : this.listOutlet), ...this.getListOutLet].map((outlet) => {
          var outletQuery = this.getQuery?.outletIds || []
          return { ...outlet, visible: outletQuery && outletQuery.length ? outletQuery.indexOf(outlet.id) > -1 : true }
        })
        this.listOutletOld = this.listOutlet
        this.isMergedOutlets = true
        this.listRegister = this.listOutlet
          .filter((e) => e.visible)
          .reduce((prev, outlet) => {
            outlet.registers = (outlet.registers || []).map((register) => {
              register.nameDisplay = register.name + ' (' + outlet.name + ')'
              return register
            })
            return [...prev, ...(outlet.registers || [])]
          }, [])
          .filter((register, index, arr) => arr.map((v) => v.id).indexOf(register.id) === index)
          .map((register) => {
            var registerQuery = this.getQuery?.registerIds || []
            return { ...register, visible: registerQuery && registerQuery.length ? registerQuery.indexOf(register.id) > -1 : true }
          })
      }
      if (!this.isMergedSalesperson && (this.salespersons || []).length > 0) {
        this.listSalespersons = this.salespersons.map((data) => {
          var salesmen = this.getQuery?.salesmen || []
          return { ...data, visible: salesmen && salesmen.length ? salesmen.indexOf(data.id) > -1 : true }
        })
        this.isMergedSalesperson = true
      }
      this.onSelectOutlet()
    }, 0)
  },
  watch: {
    isExporting: function (news, old) {
      if (old === 'start' && news === 'end') {
        let currentType = ''
        switch (this.$route.name) {
          case 'salesReport':
            currentType = reportType.products
            break
          case 'orderStatus':
          case 'paymentStatus':
          case 'salesOrder':
            currentType = reportType.orders
            break
          case 'averageDuration':
            currentType = reportType.averageDuration
            break
          case 'timeInStatus':
            currentType = reportType.timeInStatus
            break
          case 'revenueByProduct':
            currentType = reportType.productProfit
            break
          case 'productSold':
            currentType = reportType.productSold
            break
          case 'tippings':
            currentType = reportType.tippings
            break
          case 'dailyReport':
            currentType = reportType.dailyReport
            break
          case 'monthlyReport':
            currentType = reportType.monthlyReport
            break
          case 'dailyTaxReport':
            currentType = reportType.dailyTaxReport
            break
          default:
            break
        }
        if ([reportType.dailyReport, reportType.monthlyReport, reportType.dailyTaxReport].includes(currentType)) {
          return
        }
        if (currentType === reportType.tippings) {
          this.getTippingReport({
            type: currentType,
            query: {
              ...this.getQuery,
              page: 1,
              limit: 20
            }
          })
        } else {
          this.getReport({
            type: currentType,
            query: {
              ...this.getQuery,
              page: 1,
              limit: 20
            }
          })
        }
      }
    }
  },
  created() {
    if (this.$route.name === 'dailyReport') {
      const startDate = new Date()
      const endDate = new Date()
      endDate.setHours(0, 0, 0, 0)
      startDate.setHours(23, 59, 59, 999)
      this.day = {
        createdAtMin: endDate.toJSON(),
        createdAtMax: startDate.toJSON()
      }
      if (this.statesQueryData) {
        this.orderStatus = this.orderStatus.map((status) => ({ ...status, visible: this.statesQueryData.indexOf(status.value) > -1 }))
      }
      this.time_ranger = [endDate, startDate]
      this.sourceItem = (this.getQuery && this.getQuery.reportingMode) || 'in_store'
      if (this.getQuery && this.getQuery.outletIds) {
        this.fillterType = this.queryMode || this.getQuery.mode
        this.$emit('onDefaultFilter', this.day, this.fillterType, this.getQuery.source, this.getQuery.outletIds, this.getQuery.registerIds)
      } else if (this.getQuery && !this.getQuery.outletIds) {
        this.fillterType = this.queryMode || this.getQuery.mode
        this.$emit('onDefaultFilter', this.day, this.fillterType, this.sourceItem)
      } else {
        this.$emit('onDefaultFilter', this.day, this.fillterType, this.sourceItem)
      }
      this.onSelectOutlet()
      return
    }
    const startDate = new Date()
    const endDate = new Date()
    endDate.setDate(endDate.getDate() - 4)
    endDate.setHours(0, 0, 0, 0)
    startDate.setHours(23, 59, 59, 999)

    if (this.statesQueryData) {
      this.orderStatus = this.orderStatus.map((status) => ({ ...status, visible: this.statesQueryData.indexOf(status.value) > -1 }))
    }

    this.day = {
      createdAtMin: endDate.toJSON(),
      createdAtMax: startDate.toJSON()
    }
    if (this.getQuery != null && this.getQuery?.createdAtMin != null && this.getQuery?.createdAtMax != null) {
      this.time_ranger = [new Date(this.getQuery.createdAtMin), new Date(this.getQuery.createdAtMax)]
    } else {
      this.time_ranger = [endDate, startDate]
    }
    this.getColTable({
      type: this.fillterType,
      startDate: this.day.createdAtMin,
      range: 4
    })
    this.sourceItem = (this.getQuery && this.getQuery.reportingMode) || 'in_store'
    if (this.getQuery && this.getQuery.outletIds) {
      this.day = {
        createdAtMin: new Date(this.getQuery.createdAtMin).toJSON(),
        createdAtMax: new Date(this.getQuery.createdAtMax).toJSON()
      }
      this.fillterType = this.queryMode || this.getQuery.mode
      this.$emit('onDefaultFilter', this.day, this.fillterType, this.getQuery.source, this.getQuery.outletIds, this.getQuery.registerIds)
    } else if (this.getQuery && !this.getQuery.outletIds) {
      this.day = {
        createdAtMin: new Date(this.getQuery.createdAtMin).toJSON(),
        createdAtMax: new Date(this.getQuery.createdAtMax).toJSON()
      }
      this.fillterType = this.queryMode || this.getQuery.mode
      this.$emit('onDefaultFilter', this.day, this.fillterType, this.sourceItem)
    } else {
      this.$emit('onDefaultFilter', this.day, this.fillterType, this.sourceItem)
    }
    this.onSelectOutlet()
  },
  methods: {
    ...mapActions({
      getColTable: 'report/getColTable',
      getReport: 'report/getReportDataByStore',
      setExportingData: 'report/setExportingData',
      getSalesOrder: 'report/getSalesOrderByStore',
      setLoading: 'report/setLoadingReport',
      getTippingReport: 'report/getTippingReportDataByStore'
    }),
    closeMultiSelect(type) {
      this.isShowColumnsSelect = !this.isShowColumnsSelect
      if (type) {
        this.popupType = type
      }
    },
    disabledAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel
    },
    toogleShowModal(value) {
      this.showModalDateExport = value
      if (this.showModalDateExport) {
        this.dateFormatExport = 'DD/MM/YYYY HH:mm'
      }
    },
    toggleColumnFilter() {
      this.closeMultiSelect()
      this.updateKey()
      if (this.isShowColumnsSelect) {
        this.popupType = ''
        return
      }

      if ((this.$route.name === 'global' || this.$route.name === 'global-stores') && this.popupType === 'store') {
        this.$emit('onChangeListStore', this.listStore)
      }
      if (['dashboard', 'orderStatus', 'timeInStatus', 'revenueByProduct', ...this.revenueListName].includes(this.$route.name) && this.popupType === 'orderStatus') {
        this.onChangeOrderStatus()
      }
      if (this.$route.name === 'paymentStatus' && this.popupType === 'paymentStatus') {
        this.onChangePaymentStatus()
      }
      if ((this.$route.name === 'productSold' || this.$route.name === 'revenueByProduct') && this.popupType === 'productTypes') {
        this.onChangeProductType()
      }
      if (this.popupType === 'outlet') {
        const selectedOutlets = this.listOutlet.filter((outlet) => !!outlet.visible)

        if (selectedOutlets.length) {
          this.listRegister = selectedOutlets
            .reduce((prev, outlet) => [...prev, ...(outlet.registers || [])], [])
            .filter((register, index, arr) => arr.map((v) => v.id).indexOf(register.id) === index)
            .map((register) => ({ ...register, visible: true }))
        } else {
          this.listRegister = this.listOutlet
            .reduce((prev, outlet) => [...prev, ...(outlet.registers || [])], [])
            .filter((register, index, arr) => arr.map((v) => v.id).indexOf(register.id) === index)
            .map((register) => ({ ...register, visible: false }))
        }

        this.onChangeOutlet()
      }

      if (this.popupType === 'register') {
        this.onChangeOutlet()
      }

      if (this.popupType === 'tippings') {
        this.onChangeSalesperson()
      }
      this.popupType = ''
    },
    onShowFillter() {
      this.isShowFilterForm = !this.isShowFilterForm
    },
    convertDate(startDate, endDate) {
      return `${new Date(this.day.createdAtMin).toDateString()}, ${new Date(this.day.createdAtMax).toDateString()}`
    },
    changeDay(day, type, range, now, maxDate) {
      this.error = false
      this.timeChange = now || 0
      this.timeMaxChange = maxDate || 0
      this.day = day
      this.fillterType = type
      this.range = range
    },
    moment(any) {
      return moment(any)
    },
    onFilter() {
      if (this.timeChange < this.timeMaxChange) {
        this.error = true
        return
      }
      this.getColTable({
        type: this.fillterType,
        startDate: this.day.createdAtMin,
        range: this.range
      })
      let outletIds = this.listOutlet.filter((outlet) => !!outlet.visible).map((outlet) => outlet.id)
      let registerIds = this.listRegister.filter((register) => !!register.visible).map((register) => register.id)
      const targetDate = moment(new Date(this.day.createdAtMax).toISOString())
      let states = [...this.orderStatus, ...this.getCustomStatuses].filter((status) => status.visible).map((status) => status.value) || null
      let statuses = this.paymentStatus.filter((status) => status.visible).map((status) => status.value) || null

      if (!['dashboard', 'orderStatus', 'timeInStatus', 'revenueByProduct', ...this.revenueListName].includes(this.$route.name)) {
        states = []
      }
      if (this.$route.name !== 'paymentStatus') {
        statuses = []
      }
      this.day = {
        createdAtMin: this.day.createdAtMin,
        createdAtMax: targetDate.toISOString()
      }
      if (outletIds.length === this.listOutlet.length) {
        outletIds = []
      }
      if (registerIds.length === this.listRegister.length) {
        registerIds = []
      }
      this.$emit(
        'onFilterDay',
        this.day,
        this.fillterType,
        this.sourceItem,
        outletIds.length ? outletIds : null,
        registerIds.length ? registerIds : null,
        states,
        statuses
      )
      this.isFormDateFicker = !this.isFormDateFicker
      if (this.activeTab === 1) {
        this.showDateRanger = false
      }
      this.showTimeRangePanel = false
      this.updateKey()
    },
    changeDateRanger() {
      this.day = {
        createdAtMin: this.time_ranger && this.time_ranger[0] ? this.time_ranger[0] : null,
        createdAtMax: this.time_ranger && this.time_ranger[1] ? this.time_ranger[1] : null
      }
      this.range = new Date(this.day.createdAtMax).getDate() - new Date(this.day.createdAtMin).getDate()
      this.type = this.queryMode
      this.dateRangeKey += 1
    },
    changeTab(tabID) {
      this.activeTab = tabID
      if (tabID === 1) {
        this.fillterType = 'DATE'
        this.showDateRanger = true
      } else {
        this.fillterType = this.queryMode
        this.showDateRanger = false
      }
    },
    showFillter() {
      this.isFormDateFicker = !this.isFormDateFicker
      if (this.isFormDateFicker && this.activeTab === 1) {
        this.showDateRanger = true
      } else {
        this.showDateRanger = false
      }
    },
    onChangeOutlet() {
      const outletList = this.listOutlet
      const registerList = this.listRegister
      let outletIds = outletList.filter((outlet) => !!outlet.visible).map((outlet) => outlet.id)
      let registerIds = registerList.filter((register) => !!register.visible).map((register) => register.id)
      if (this.sourceItem === 'online') {
        outletIds = []
        registerIds = []
      }
      if (!outletIds.length && this.sourceItem !== 'online') {
        outletIds = ['-1']
      }
      if (!registerIds.length && this.sourceItem !== 'online') {
        registerIds = ['-1']
      }

      if (outletIds.filter((e) => e !== '-1').length === this.listOutlet.length) {
        outletIds = []
      }
      if (registerIds.filter((e) => e !== '-1').length === this.listRegister.length) {
        registerIds = []
      }

      const states = [...this.orderStatus, ...this.getCustomStatuses].filter((status) => status.visible).map((status) => status.value) || null
      const statuses = this.paymentStatus.filter((status) => status.visible).map((status) => status.value) || null
      const types = this.productTypes.filter((productType) => productType.visible).map((productType) => productType.value) || null
      setLocalStorage(localStorageKey.CURRENT_OUTLET_ID, JSON.stringify(outletIds || (this.listOutlet || []).map((outlet) => outlet.id)))
      this.$emit(
        'onChangeOutlet',
        this.sourceItem,
        outletIds.length ? outletIds : null,
        registerIds.length ? registerIds : null,
        this.day,
        this.fillterType,
        states,
        statuses,
        types
      )
      this.updateKey()
    },
    onChangeOrderStatus() {
      let outletIds = this.listOutlet.filter((outlet) => !!outlet.visible).map((outlet) => outlet.id)
      let registerIds = this.listRegister.filter((register) => !!register.visible).map((register) => register.id)
      if (this.sourceItem === 'online') {
        outletIds = []
        registerIds = []
      }
      if (outletIds.length === this.listOutlet.length) {
        outletIds = []
      }
      if (registerIds.length === this.listRegister.length) {
        registerIds = []
      }

      this.status = null
      const states = [...this.orderStatus, ...this.getCustomStatuses].filter((status) => status.visible).map((status) => status.value) || null
      this.$emit(
        'onChangeOrderStatus',
        this.sourceItem,
        outletIds.length ? outletIds : null,
        registerIds.length ? registerIds : null,
        this.day,
        this.fillterType,
        states
      )
      this.updateKey()
    },
    onChangePaymentStatus() {
      let outletIds = this.listOutlet.filter((outlet) => !!outlet.visible).map((outlet) => outlet.id)
      let registerIds = this.listRegister.filter((register) => !!register.visible).map((register) => register.id)
      if (this.sourceItem === 'online') {
        outletIds = []
        registerIds = []
      }
      if (outletIds.length === this.listOutlet.length) {
        outletIds = []
      }
      if (registerIds.length === this.listRegister.length) {
        registerIds = []
      }

      this.state = null
      const statuses = this.paymentStatus.filter((status) => status.visible).map((status) => status.value) || null
      this.$emit(
        'onChangePaymentStatus',
        this.sourceItem,
        outletIds.length ? outletIds : null,
        registerIds.length ? registerIds : null,
        this.day,
        this.fillterType,
        statuses
      )
      this.updateKey()
    },
    onChangeSalesperson() {
      const salemen = this.listSalespersons.filter((status) => status.visible).map((status) => status.username) || null
      this.$emit('onChangeSalesperson', salemen)
      this.updateKey()
    },
    onChangeProductType() {
      let outletIds = this.listOutlet.filter((outlet) => !!outlet.visible).map((outlet) => outlet.id)
      let registerIds = this.listRegister.filter((register) => !!register.visible).map((register) => register.id)
      if (this.sourceItem === 'online') {
        outletIds = []
        registerIds = []
      }
      if (outletIds.length === this.listOutlet.length) {
        outletIds = []
      }
      if (registerIds.length === this.listRegister.length) {
        registerIds = []
      }

      this.state = null
      this.status = null
      const types = this.productTypes.filter((productType) => productType.visible).map((productType) => productType.value) || null
      this.$emit(
        'onChangeProductType',
        this.sourceItem,
        outletIds.length ? outletIds : null,
        registerIds.length ? registerIds : null,
        this.day,
        this.fillterType,
        types
      )
      this.updateKey()
    },
    getOutletRegisterName(outletId, registerId) {
      const outlet = this.getListOutLet.find((outlet) => outlet.id === outletId)
      if (outlet) {
        const outletName = outlet.name

        const register = (outlet.registers || []).find((registerObj) => registerObj.id === registerId)

        return outletName + (register ? ' - ' + register.name : '')
      }
      return ''
    },
    getCustomerName(customer) {
      if (!customer) {
        return ''
      }
      return customer.firstName + (customer.lastName ? ` ${customer.lastName}` : '')
    },
    getStatus(code) {
      const customStatus = (this.getCustomStatuses || []).find((status) => status.value === code && status.is_published)
      if (customStatus) {
        return customStatus.label
      }
      return orderStatus[code]
    },
    getPaymentStatus(code) {
      return paymentStatus[code]
    },
    getFulfillmentStatus(code) {
      return fulfillmentStatus[code]
    },
    getSource(code) {
      return source[code]
    },
    getPaymentInfo(payment) {
      let info = ''
      for (let i = 0; i < payment.length; i++) {
        if (info !== '') {
          info = info + '\n' + `Payment ${i + 1}: ${payment[i].paymentName} - ref: ${payment[i].referenceNumber || ''}`
        } else {
          info = `Payment ${i + 1}: ${payment[i].paymentName} - ref: ${payment[i].referenceNumber || ''}`
        }
      }
      return info
    },
    getJsonDataForOrder() {
      let data = this.getJsonDataOrder
      data = (data || []).map((order) => {
        let payment = {}
        for (let index = 0; index < (order.paymentInfo || []).length; index++) {
          payment = {
            ...payment,
            [`paymentMethodName${index + 1}`]: order.paymentInfo[index].paymentName,
            [`paymentMethodAmount${index + 1}`]: order.paymentInfo[index].amount,
            [`paymentMethodRef${index + 1}`]: order.paymentInfo[index].referenceNumber
          }
        }
        return {
          orderName: order.posOrderId || order.name || order.number,
          createdAt: moment(order.createdAt).format('MMM/DD/YYYY HH:mm:ss'),
          outletRegister: this.getOutletRegisterName(order.outletId, order.registerId),
          customerName: this.getCustomerName(order.customer),
          totalPrice: order.totalPrice,
          subtotalIncTax: order.subtotalIncTax,
          subtotalExTax: order.subtotalExTax,
          totalTax: order.totalTax,
          refundedTotalPrice: order.refundedTotalPrice,
          totalDiscounts: order.totalDiscounts,
          orderStatus: this.getStatus(order.state),
          fulfillmentStatus: this.getFulfillmentStatus(order.fulfillmentStatus),
          paymentStatus: this.getPaymentStatus(order.status),
          orderStatusUpdatedAt: moment(order.orderStatusUpdatedAt).format('MMM/DD/YYYY HH:mm:ss'),
          paymentStatusUpdatedAt: moment(order.paymentStatusUpdatedAt).format('MMM/DD/YYYY HH:mm:ss'),
          source: this.getSource(order.source),
          paymentInfo: this.getPaymentInfo(order.paymentInfo || []),
          orderNote: order.orderNote,
          staffNote: order.staffNote,
          totalPaid: order.totalPaid,
          totalTip: order.totalTip,
          ...payment
        }
      })
      return data
    },
    getDuration(duration) {
      const avg = Number(duration)
      return (avg > 9 ? '' : '0') + avg.toFixed(2)
    },
    getJsonDataForOrderDuration() {
      let data = this.getJsonDataOrder
      data = (data || []).map((order) => ({
        created_at: order.created_at,
        order_number: order.order_number,
        outletRegister: this.getOutletRegisterName(order.outlet_id, order.register_id),
        customerName: order.first_name ? order.first_name + (order.last_name ? ` ${order.last_name}` : '') : '',
        avg_duration: this.getDuration(order.avg_duration)
      }))
      return data
    },
    getJsonDataForOrderTimeInStatus() {
      let data = this.getJsonDataOrder
      data = (data || []).map((order) => {
        const statusesReport = {}
        if (!this.statesQueryData) {
          this.statesQueryData = []
        }

        this.statesQueryData.forEach((state) => {
          if (order.timeInStatuses) {
            statusesReport[state] = order.timeInStatuses[state]
          }
        })
        return {
          created_at: order.created_at,
          order_number: order.order_number,
          outletRegister: this.getOutletRegisterName(order.outlet_id, order.register_id),
          customerName: order.first_name ? order.first_name + (order.last_name ? ` ${order.last_name}` : '') : '',
          ...statusesReport,
          total: this.getDuration(order.total)
        }
      })
      return data
    },
    getJsonDataForSaleReport() {
      let data = this.getJsonData
      data = (data || []).map((order) => {
        const element = { ...order }
        for (let index = 0; index < this.getSellReport.paymentsCount.length; index++) {
          if (element[`processedAt_${index + 1}`]) {
            element[`processedAt_${index + 1}`] = moment(element[`processedAt_${index + 1}`], 'DD/MM/YYYY HH:mm').format(this.dateFormatExport)
          }
          if (!element[`paymentName_${index + 1}`]) {
            element[`processedAt_${index + 1}`] = ''
            element[`amount_${index + 1}`] = ''
          }
        }
        if (element.createdAt) {
          element.createdAt = moment(element.createdAt, 'DD/MM/YYYY HH:mm').format(this.dateFormatExport)
        }
        return element
      })
      return data
    },
    getJsonDataForTippings() {
      let data = this.getJsonDataOrder
      data = (data || []).map((order) => ({
        createdAt: this.moment(order.orderCreatedAt).format('MMM/DD/YYYY HH:mm'),
        orderNumber: order.orderNumber,
        outletRegister: this.getOutletRegisterName(order.outletId, order.registerId),
        customerName: `${order.firstName || ''} ${order.lastName || ''}`,
        orderTotalPrice: order.orderTotalPrice,
        salePerson: order.salesmanName ?? order.cashierName,
        amount: order.amount,
        tippedCreatedAt: this.moment(order.tippedCreatedAt).format('MMM/DD/YYYY HH:mm')
      }))
      return data
    },
    onGetDataExport() {
      this.setExportingData('start')
      let currentType = ''
      switch (this.$route.name) {
        case 'salesReport':
          currentType = reportType.products
          break
        case 'orderStatus':
        case 'paymentStatus':
        case 'salesOrder':
          currentType = reportType.orders
          break
        case 'averageDuration':
          currentType = reportType.averageDuration
          break
        case 'timeInStatus':
          currentType = reportType.timeInStatus
          break
        case 'revenueByProduct':
          currentType = reportType.productProfit
          break
        case 'productSold':
          currentType = reportType.productSold
          break
        case 'tippings':
          currentType = reportType.tippings
          break
        case 'dailyReport':
          currentType = reportType.dailyReport
          break
        case 'monthlyReport':
          currentType = reportType.monthlyReport
          break
        default:
          break
      }
      if (currentType === reportType.tippings) {
        return this.getTippingReport({
          type: currentType,
          isExportExcel: true,
          query: {
            ...this.getQuery,
            page: 1,
            limit: this.count_items > 100 ? 100 : this.count_items + 1
          }
        }).then(() => {
          this.setExportingData('end')
          this.showModalDateExport = false
          return this.getJsonDataForTippings()
        })
      } else {
        return this.getReport({
          type: currentType,
          isExportExcel: true,
          query: {
            ...this.getQuery,
            page: 1,
            limit: this.count_items > 100 ? 100 : this.count_items + 1
          }
        }).then(() => {
          this.setExportingData('end')
          this.showModalDateExport = false
          switch (this.$route.name) {
            case 'salesReport':
              return this.getJsonDataForSaleReport()
            case 'orderStatus':
            case 'paymentStatus':
            case 'salesOrder':
              return this.getJsonDataForOrder()
            case 'averageDuration':
              return this.getJsonDataForOrderDuration()
            case 'timeInStatus':
              return this.getJsonDataForOrderTimeInStatus()
            case 'revenueByProduct':
              return this.getJsonData
            case 'productSold':
              return this.getJsonData
            case 'dailyReport':
              return this.dailyReportData.dataExport
            case 'monthlyReport':
              return this.monthlyReportData.dataExport
            default:
              break
          }
        })
      }
    },
    checkAllOutletsAction(event) {
      this.listOutlet = (this.listOutlet || []).map((outlet, index) => {
        outlet.visible = this.checkAllOutlets
        return outlet
      })
      this.updateKey()
    },
    checkAllOrderStatus(event) {
      if (event.target.checked) {
        this.orderStatus = this.orderStatus.map(status => ({ ...status, visible: true }))
      } else {
        this.orderStatus = this.orderStatus.map(status => ({ ...status, visible: false }))
      }
    },
    onSelectOutlet() {
      const isUncheckOutlet = (element) => !element.visible
      var indexUncheckOutlet = (this.listOutlet || []).findIndex(isUncheckOutlet)
      this.checkAllOutlets = indexUncheckOutlet < 0
    },
    updateKey() {
      this.dateRangeKey = Math.random()
      this.compareDateKey = Math.random()
      this.outletsKey = Math.random()
      this.registersKey = Math.random()
      this.salesPersonKey = Math.random()
      this.paymentStatusKey = Math.random()
      this.orderStatusKey = Math.random()
      this.productTypesKey = Math.random()
      this.dateInputKey = Math.random()
      this.datePickerKey = Math.random()
    },
    onFilterCategory(categoryIds, filterBy) {
      this.getReport({
        type: reportType.categories,
        query: { ...this.reportQuery, page: 1, limit: 100, categoryIds: categoryIds, filterBy: filterBy }
      })
      this.closeMultiSelect('allCategories')
    },
    getBase64Image() {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const svgElement = document.querySelector('.highcharts-root')
        const imageBlobURL = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgElement.outerHTML)
        img.onload = () => {
          var canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          const dataURL = canvas.toDataURL('image/png')
          resolve(dataURL)
        }
        img.onerror = (error) => {
          reject(error)
        }
        img.src = imageBlobURL
      })
    },
    getCurrentTotalPrice(total, currencyExchangeRate = null) {
      // data of order multipled by rate from BE (Must be that from BE)
      if (currencyExchangeRate && total) {
        return Number(total) / Number(currencyExchangeRate)
      }
      return total
    },
    formatTotal(total, currencyExchangeRate = null, presentmentCurrency = null) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY) || {}
      const toCurrencyKey = 'toCurrency'
      const toCurrency = currentCurrent[toCurrencyKey]
      var rate =
        presentmentCurrency && currencyExchangeRate && toCurrency === presentmentCurrency ? currencyExchangeRate : currentCurrent?.rate || '1'
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(rate)).toFixed(2), { maxFraction: 2 })}`
    },
    async exportPdf() {
      var pdfMake = require('pdfmake/build/pdfmake.js')
      pdfMake.vfs = fontNotoSanThai.font
      pdfMake.fonts = {
        NotoSansThai: {
          normal: 'NotoSansThai-Light',
          bold: 'NotoSansThai-Medium',
          italics: 'NotoSansThai-LightItalic',
          bolditalics: 'NotoSansThai-MediumItalic'
        }
      }
      var pageWidth = 900
      var pageHeigth = 1000
      var image = await this.getBase64Image()
      var summary = Object.entries(this.report.items || []).reduce((prev, next) => {
        return Number(next[1].totalRevenue || '0') + prev
      }, 0)
      await this.getSalesOrder({
        isExportExcel: true
      }).then(async () => {
        var bodyOrderData = [{}]
        var layoutOrderData = {}
        if ((this.salesOrderData || []).length !== 0) {
          bodyOrderData = [
            [
              { text: i18n.t('outlet'), style: 'header' },
              { text: i18n.t('cashier'), style: 'header' },
              { text: i18n.t('created_date'), style: 'header' },
              { text: i18n.t('order_number'), style: 'header' },
              { text: i18n.t('subtotal'), style: 'header' },
              { text: i18n.t('discount'), style: 'header' },
              { text: i18n.t('return'), style: 'header' },
              { text: i18n.t('tax'), style: 'header' },
              { text: i18n.t('total'), style: 'header' }
            ],
            ...(this.salesOrderData || []).map((e) => {
              var currencyExchangeRate = (e.paymentInfo || []).length > 0 ? e.paymentInfo[0].currencyExchangeRate : null
              var presentmentCurrency = (e.paymentInfo || []).length > 0 ? e.paymentInfo[0].presentmentCurrency : null
              return [
                { text: e.outletName || '', style: 'content' },
                { text: e.cashierName || '', style: 'content' },
                { text: i18n.d(new Date(moment(e.createdAt).toDate().toUTCString()), 'long') || '', style: 'content' },
                { text: e.orderNumber || '', style: 'content' },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.subtotalExTax || Number(e.subtotalIncTax) - Number(e.totalTax) || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalDiscounts || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.refundedTotalPrice || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalTax || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(
                      Number(e.subtotalIncTax || '0') +
                      Number(e.totalShipping || '0') -
                      Number(e.totalDiscounts || '0') -
                      Number(e.refundedTotalPrice || '0'),
                      currencyExchangeRate
                    ),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                }
              ]
            })
          ]
          layoutOrderData = {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? '#CCCCCC' : null
            },
            hLineWidth: function (i, node) {
              return i === 0 || i === (node.table.body || []).length ? 1 : 0.5
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === (node.table.widths || []).length ? 1 : 0.5
            },
            hLineColor: function (i, node) {
              return i === 0 || i === (node.table.body || []).length ? '#3D3D3D' : 'gray'
            },
            vLineColor: function (i, node) {
              return i === 0 || i === (node.table.widths || []).length ? '#3D3D3D' : 'gray'
            }
          }
        }
        var docDefinition = {
          pageSize: {
            width: pageWidth,
            height: pageHeigth
          },
          content: [
            {
              image: image,
              width: pageWidth - 100
            },
            {
              margin: [0, 10],
              table: {
                widths: ['*', '*'],
                heights: 20,
                body: [
                  [
                    { text: i18n.t('date'), style: 'header' },
                    { text: i18n.t('revenue'), style: 'header' }
                  ],
                  [
                    { text: i18n.t('summary'), style: 'content' },
                    {
                      text: this.formatTotal(summary || '0'),
                      style: 'content'
                    }
                  ],
                  ...Object.entries(this.report.items || []).map((e) => {
                    return [
                      {
                        text: i18n.d(
                          new Date(
                            moment(e[0] || '')
                              .toDate()
                              .toUTCString()
                          ), 'short'
                        ),
                        style: 'content'
                      },
                      {
                        text: this.formatTotal(e[1].totalRevenue || '0', e[1].currencyExchangeRate, e[1].presentmentCurrency),
                        style: 'content'
                      }
                    ]
                  })
                ]
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex === 0 ? '#CCCCCC' : null
                },
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 1 : 0.5
                },
                vLineWidth: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? 1 : 0.5
                },
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#3D3D3D' : 'gray'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? '#3D3D3D' : 'gray'
                }
              }
            },
            {
              table: {
                heights: 20,
                widths: [120, 85, 120, 70, 70, 70, 70, 70, 70, 70],
                body: bodyOrderData
              },
              layout: layoutOrderData
            }
          ],
          defaultStyle: {
            font: 'NotoSansThai'
          },
          styles: {
            header: {
              alignment: 'center',
              bold: true,
              margin: [0, 5, 0, 5]
            },
            content: {
              margin: [10, 3, 0, 0]
            }
          }
        }
        this.setLoading(false)
        pdfMake.createPdf(docDefinition).download(`CReport_totalRevenue_by_${this.fillterType.toLowerCase()}.pdf`)
      })
    },
    async exportDailyPdf() {
      var pdfMake = require('pdfmake/build/pdfmake.js')
      pdfMake.vfs = fontNotoSanThai.font
      pdfMake.fonts = {
        NotoSansThai: {
          normal: 'NotoSansThai-Light',
          bold: 'NotoSansThai-Medium',
          italics: 'NotoSansThai-LightItalic',
          bolditalics: 'NotoSansThai-MediumItalic'
        }
      }
      var pageWidth = 900
      var pageHeigth = 1000
      await this.onGetDataExport({
      }).then(async () => {
        var bodyOrderData = [{}]
        var layoutOrderData = {}
        if ((this.dailyReportData.dataExport || []).length !== 0) {
          bodyOrderData = [
            [
              { text: i18n.t('order_name'), style: 'header' },
              { text: i18n.t('cashier'), style: 'header' },
              { text: i18n.t('date'), style: 'header' },
              { text: i18n.t('total_prior_to_discount'), style: 'header' },
              { text: i18n.t('discount_total'), style: 'header' },
              { text: i18n.t('tax_after_discount'), style: 'header' },
              { text: i18n.t('total'), style: 'header' },
              { text: i18n.t('refund_includes_tax'), style: 'header' }
            ],
            ...(this.dailyReportData.dataExport || []).map((e) => {
              var currencyExchangeRate = (e.paymentInfo || []).length > 0 ? e.paymentInfo[0].currencyExchangeRate : null
              var presentmentCurrency = (e.paymentInfo || []).length > 0 ? e.paymentInfo[0].presentmentCurrency : null
              return [
                { text: e.orderNumber || '', style: 'content' },
                { text: e.cashierName || '', style: 'content' },
                { text: e.createdAt === 'Grand total' ? i18n.t('grand_total') : i18n.d(new Date(moment(e.createdAt).toDate().toUTCString()), 'long') || '', style: 'content' },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.subtotalPrice || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalDiscount || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.tax || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalPrice || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalRefunded || '0', currencyExchangeRate
                    ),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                }
              ]
            })
          ]
          layoutOrderData = {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? '#CCCCCC' : null
            },
            hLineWidth: function (i, node) {
              return i === 0 || i === (node.table.body || []).length ? 1 : 0.5
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === (node.table.widths || []).length ? 1 : 0.5
            },
            hLineColor: function (i, node) {
              return i === 0 || i === (node.table.body || []).length ? '#3D3D3D' : 'gray'
            },
            vLineColor: function (i, node) {
              return i === 0 || i === (node.table.widths || []).length ? '#3D3D3D' : 'gray'
            }
          }
        }
        var docDefinition = {
          pageSize: {
            width: pageWidth,
            height: pageHeigth
          },
          content: [
            {
              margin: [0, 10],
              table: {
                body: [
                  []
                ]
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex === 0 ? '#CCCCCC' : null
                },
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 1 : 0.5
                },
                vLineWidth: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? 1 : 0.5
                },
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#3D3D3D' : 'gray'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? '#3D3D3D' : 'gray'
                }
              }
            },
            {
              table: {
                heights: 20,
                widths: [120, 120, 155, 70, 70, 70, 70, 70, 70],
                body: bodyOrderData
              },
              layout: layoutOrderData
            }
          ],
          defaultStyle: {
            font: 'NotoSansThai'
          },
          styles: {
            header: {
              alignment: 'center',
              bold: true,
              margin: [0, 5, 0, 5]
            },
            content: {
              margin: [10, 3, 0, 0]
            }
          }
        }
        this.setLoading(false)
        pdfMake.createPdf(docDefinition).download(`CReport_totalRevenue_by_${this.fillterType.toLowerCase()}.pdf`)
      })
    },
    async exportMonthlyPdf() {
      var pdfMake = require('pdfmake/build/pdfmake.js')
      pdfMake.vfs = fontNotoSanThai.font
      pdfMake.fonts = {
        NotoSansThai: {
          normal: 'NotoSansThai-Light',
          bold: 'NotoSansThai-Medium',
          italics: 'NotoSansThai-LightItalic',
          bolditalics: 'NotoSansThai-MediumItalic'
        }
      }
      var pageWidth = 900
      var pageHeigth = 1000
      await this.onGetDataExport({
      }).then(async () => {
        var bodyOrderData = [{}]
        var layoutOrderData = {}
        if ((this.monthlyReportData.dataExport || []).length !== 0) {
          bodyOrderData = [
            [
              { text: i18n.t('product_tax_class'), style: 'header' },
              { text: i18n.t('total_tax_excluded'), style: 'header' },
              { text: i18n.t('discount_total'), style: 'header' },
              { text: i18n.t('tax'), style: 'header' },
              { text: i18n.t('total_tax_exempt'), style: 'header' },
              { text: i18n.t('total'), style: 'header' },
              { text: i18n.t('refund_includes_tax'), style: 'header' }
            ],
            ...(this.monthlyReportData.dataExport || []).map((e) => {
              var currencyExchangeRate = (e.paymentInfo || []).length > 0 ? e.paymentInfo[0].currencyExchangeRate : null
              var presentmentCurrency = (e.paymentInfo || []).length > 0 ? e.paymentInfo[0].presentmentCurrency : null
              return [
                { text: e.productCategory || '', style: 'content' },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.subtotalPrice || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalDiscount || '0', currencyExchangeRate
                    ),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.tax || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalPrice || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalPriceInReport || '0', currencyExchangeRate),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                },
                {
                  text: this.formatTotal(
                    this.getCurrentTotalPrice(e.totalRefunded || '0', currencyExchangeRate
                    ),
                    currencyExchangeRate,
                    presentmentCurrency
                  ),
                  style: 'content'
                }
              ]
            })
          ]
          layoutOrderData = {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? '#CCCCCC' : null
            },
            hLineWidth: function (i, node) {
              return i === 0 || i === (node.table.body || []).length ? 1 : 0.5
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === (node.table.widths || []).length ? 1 : 0.5
            },
            hLineColor: function (i, node) {
              return i === 0 || i === (node.table.body || []).length ? '#3D3D3D' : 'gray'
            },
            vLineColor: function (i, node) {
              return i === 0 || i === (node.table.widths || []).length ? '#3D3D3D' : 'gray'
            }
          }
        }
        var docDefinition = {
          pageSize: {
            width: pageWidth,
            height: pageHeigth
          },
          content: [
            {
              margin: [0, 10],
              table: {
                body: [
                  []
                ]
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex === 0 ? '#CCCCCC' : null
                },
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 1 : 0.5
                },
                vLineWidth: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? 1 : 0.5
                },
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#3D3D3D' : 'gray'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? '#3D3D3D' : 'gray'
                }
              }
            },
            {
              table: {
                heights: 20,
                widths: [120, 120, 155, 70, 70, 70, 70, 70, 70],
                body: bodyOrderData
              },
              layout: layoutOrderData
            }
          ],
          defaultStyle: {
            font: 'NotoSansThai'
          },
          styles: {
            header: {
              alignment: 'center',
              bold: true,
              margin: [0, 5, 0, 5]
            },
            content: {
              margin: [10, 3, 0, 0]
            }
          }
        }
        this.setLoading(false)
        pdfMake.createPdf(docDefinition).download(`CReport_totalRevenue_by_${this.fillterType.toLowerCase()}.pdf`)
      })
    },
    getLangForDatepicker(lang) {
      switch (lang) {
        case 'fr':
          return fr
        default:
          return en
      }
    }
  }
}
</script>

<style lang="scss">
.filterWapper {
  background: var(--primary-color);
  border-radius: 4px;
  margin-bottom: 30px;
  padding: 20px 20px;
}

.filter {
  display: flex;
  justify-content: space-between;

  .btn {
    text-transform: uppercase;
    color: #818181;
    background-color: #ebebeb;
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }

  &__action {
    display: flex;
    align-items: center;
    padding-right: 30px;

    .btn-filter {
      background-color: #3b4556;
      font-size: 13px;
      min-width: unset;
      font-weight: 600;
      outline: none;
      text-transform: uppercase;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
    }

    .date-group {
      margin-left: 15px;
      display: flex;
      position: relative;

      span {
        display: flex !important;
        background: #e9eef1;
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        cursor: pointer;
      }

      .div-input {
        cursor: pointer;
        height: 40px;
        width: auto;
        display: flex;
        align-items: center;
        border: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        outline: none;
        padding: 6px 12px;
        background-color: #fff;
      }

      .calendar-group {
        position: absolute;
        top: 42px;
        left: 0;
        min-width: 600px;
        background-color: #fff;
        border-radius: 4px;
        z-index: 12;
        border: 1px solid #acacac;
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

        .time-result {
          background-color: #f5f5f5;
          padding: 30px 20px 30px 33px;
          margin-bottom: 0;
          border-radius: 0 0 4px 4px;
          margin-top: 0;
          display: flex;
          align-content: center;
          align-items: center;

          .btn {
            background-color: var(--primary-color);
            color: #fff;
            margin-left: 20px;
          }

          .btn:hover {
            background-color: var(--primary-bold-color);
          }

          .date-value {
            font-weight: 550;
            font-size: 16px;
            line-height: 25px;
          }

          div {
            width: 50%;
          }
        }

        .tab-content {
          .error {
            padding: 10px;
            color: red;
            margin: 0.5rem;
          }
        }
      }
    }

    .outlet-group {
      margin-left: 15px;

      select {
        padding: 0 15px;
        margin: 0;
        height: 39px;
        min-width: 100px;
        outline: none;
        border-radius: 4px;
        border: 0;
        background-color: #fff;
      }
    }
  }

  &__button {
    .btn-csv {
      margin-right: 10px;
    }

    .btn-csv:hover {
      color: #333;
      background-color: #e6e6e6;

      &[disabled] {
        opacity: 0.75;
        cursor: not-allowed;
        color: #818181;
      }
    }

    .btn-customize {
      background: transparent;
      border: 2px solid #fff;
      color: #fff;
    }
  }
}

.filter__button {
  display: flex;
}

.filter-fields {
  background-color: #fff;
  padding: 15px 20px;
  margin-top: 15px;
  border-radius: 4px;
  position: relative;

  .form-filter {
    display: flex;
    flex-wrap: wrap;
  }

  .form-group {
    width: 25%;
    margin-bottom: 30px;

    .input-wapper {
      display: flex;
      flex-direction: column;
      padding-right: 15px;
      padding-left: 15px;

      label {
        margin-bottom: 5px;
      }

      input {
        font-weight: 400;
        padding: 6px 12px;
        background-color: #e9eef1;
        height: 40px;
        border: 0;
        border-radius: 4px;
        outline: none;
      }
    }
  }

  .filter-fields-action {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #d6dde1;
    padding-top: 20px;
    padding-right: 5px;
    width: 100%;

    .btn-reset {
      margin-right: 15px;
      background-color: #f4a522;
      color: #fff;
      outline: none;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .btn-apply {
      background-color: var(--primary-color);
      color: #fff;
      outline: none;
      outline: none;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .fields-icon {
    position: relative;
    top: -22px;
    right: 5px;
  }
}

.label-select {
  margin-bottom: 10px;
}

.select-date {
  padding: 8px;
  border: 1px solid gray;
  border-radius: 3px;
  font-size: 15px;
}

.box-button {
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;

  .button {
    padding: 10px;
    border-radius: 3px;
    border: none;
    font-weight: 600;
    color: white;
    margin-right: 15px;
    min-width: 80px;
    background-color: #c9c9c9;
    cursor: pointer;
    font-size: 15px;
  }

  .cancel {
    background-color: #c9c9c9;
  }

  .accept {
    background-color: var(--primary-color);
  }
}

.tabs {
  background-color: #f5f5f5;
  display: flex;
  border-bottom: 2px solid #e6eaed;

  li {
    padding: 17px;
    width: 50%;
    text-align: center;
    text-transform: uppercase;
    font-size: 14px;
    cursor: pointer;
  }

  .active {
    border-bottom: 2px solid var(--primary-color) !important;
    color: var(--primary-color);
  }

  li:hover {
    border-bottom: 2px solid var(--primary-color) !important;
    color: var(--primary-color);
  }
}

.tabs--white {
  background: #fff;
}

.tab-content-ranger {
  min-height: 450px;
  position: relative;

  .time-result {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}

.mx-datepicker-main.mx-datepicker-popup {
  left: 120px !important;
}

.mx-datepicker.mx-datepicker-range {
  visibility: hidden;
}

.multi-select-button {
  min-width: 140px;
  font-size: 13px;
  font-weight: 600;
  outline: none;
}

.column-filter-wrapper-filter-ui {
  text-align: right;
  position: relative;
  padding: 0 0 0 30px;

  button {
    background-color: #fff !important;

    &:hover {
      background-color: #ebebeb !important;
    }
  }

  .popup-container {
    position: absolute;
    z-index: 12;
    width: 330px;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background: #e9eef1;

    ul {
      text-align: left;
      left: 30px;
      right: 0;
      padding: 20px;
      top: 100%;
      max-height: 400px;
      overflow-y: scroll;

      li {
        padding: 5px 0;

        label {
          cursor: pointer;
        }
      }
    }

    .apply-container {
      text-align: end;
      padding: 8px;

      .customize-button {
        background: var(--primary-color) !important;
        color: #fff !important;

        &:hover {
          background: var(--primary-bold-color) !important;
        }
      }
    }

    .d-flex {
      display: flex;
    }

    .justify-content-between {
      justify-content: space-between;
    }

    .align-items-center {
      align-items: center;
    }
  }
}

.export-pdf {
  padding: 10px;
  border: none;
  text-transform: uppercase;
  color: #818181;
  background-color: #ebebeb;
  min-width: 140px;
  font-size: 13px;
  font-weight: 600;
  outline: none;
  border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
}

@include media_tablet {
  .filter-fields {
    .form-group {
      width: 50%;
    }
  }
}
</style>
